import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HotelOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HotelOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M4.78367 11.1929C4.63564 11.1929 4.48908 11.1489 4.36304 11.0639C4.15687 10.9242 4.03327 10.6916 4.03327 10.4425V6.34357C4.03327 5.02548 5.10562 3.95264 6.4242 3.95264H17.733C19.0516 3.95264 20.1244 5.02548 20.1244 6.34357V10.4415C20.1244 10.7121 19.9788 10.9613 19.7439 11.0942C19.5089 11.229 19.2201 11.2231 18.9881 11.0854L18.6314 10.8714C18.5293 10.8733 18.5005 10.8743 18.4057 10.8343C17.1971 10.3379 14.7675 9.50346 12.0786 9.50346C9.39161 9.50346 6.96159 10.3379 5.75245 10.8343C5.66402 10.8714 5.56973 10.8899 5.47398 10.8909L5.06214 11.1391C4.97225 11.1753 4.87796 11.1929 4.78367 11.1929ZM6.4242 5.45344C5.93322 5.45344 5.53408 5.85307 5.53408 6.34357V9.3061C6.93229 8.76382 9.37745 8.00267 12.0786 8.00267C14.7812 8.00267 17.2254 8.76382 18.6236 9.3061V6.34357C18.6236 5.85308 18.224 5.45344 17.733 5.45344H6.4242Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.6887 20.0463H3.4905C2.71811 20.0463 2.08984 19.418 2.08984 18.6461V11.9872C2.08984 11.4997 2.34975 11.0395 2.76794 10.7864L4.3982 9.81029C4.61268 9.68229 4.87991 9.66666 5.10611 9.77316C5.45541 9.94023 6.65577 10.4864 8.29923 10.9007C10.9193 11.5632 13.2408 11.5632 15.8575 10.9007C16.6831 10.6926 17.3984 10.4503 17.947 10.2412C17.9367 10.165 17.9382 10.0848 17.9529 10.0057C18.0173 9.65688 18.3168 9.40089 18.6715 9.39111C18.927 9.38916 19.1811 9.45169 19.4038 9.58555L21.4088 10.7844L21.4118 10.7864C21.8299 11.0395 22.0898 11.4997 22.0898 11.9872V18.6461C22.0898 19.418 21.4611 20.0463 20.6887 20.0463ZM3.58966 18.5454H20.589V12.0429L19.3369 11.2935C18.7335 11.5612 17.6324 12.0009 16.2249 12.3566C13.3679 13.0777 10.7937 13.0777 7.93184 12.3566C6.53168 12.0029 5.41926 11.5573 4.8335 11.2994L3.54178 12.0723L3.58966 18.5454Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HotelOutlineIcon;
